const setupTabs = () => {
  const tabElements = document.querySelectorAll<HTMLElement>('.yt-o-tabs');

  tabElements.forEach((tabElement) => {
    // Desktop collection
    const tabButtons = Array.from(tabElement.querySelectorAll<HTMLButtonElement>('.nav-link'));
    const tabContents = Array.from(tabElement.querySelectorAll<HTMLElement>('.tab-pane'));

    // Mobile
    const buttonDropdown = tabElement.querySelector<HTMLButtonElement>('.btn.dropdown-toggle');
    const idDropdown = buttonDropdown?.getAttribute('id');
    const dropdownMenu = tabElement.querySelector<HTMLElement>('.dropdown-menu');
    const dropdownOptions = dropdownMenu ? Array.from(dropdownMenu.querySelectorAll<HTMLButtonElement>('.dropdown-item')) : [];

    const normalizeTarget = (target: string | null) => {
      if (!target) {
        return null;
      }

      return target.startsWith('#') ? target.slice(1) : target;
    };

    const closeDropdown = () => {
      if (!buttonDropdown || !dropdownMenu) {
        return;
      }

      buttonDropdown.setAttribute('aria-expanded', 'false');
      buttonDropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
    };

    const handleOutsideClick = (event: MouseEvent) => {
      if (!buttonDropdown || !dropdownMenu || buttonDropdown.getAttribute('aria-expanded') !== 'true') {
        return;
      }

      const target = event.target;

      if (!(target instanceof Node)) {
        return;
      }

      if (!buttonDropdown.contains(target) && !dropdownMenu.contains(target)) {
        closeDropdown();
      }
    };

    const activateTab = (targetId: string | null) => {
      const normalizedTarget = normalizeTarget(targetId);

      if (!normalizedTarget) {
        return;
      }

      const withHashTarget = `#${normalizedTarget}`;

      // Deactivate all buttons, options, and contents
      tabButtons.forEach((btn) => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });

      dropdownOptions.forEach((option) => {
        option.classList.remove('active');
        option.removeAttribute('aria-current');
      });

      tabContents.forEach((content) => {
        content.classList.remove('show', 'active');
        content.setAttribute('aria-hidden', 'true');
      });

      // Activate matching desktop button
      const desktopButton = tabButtons.find(
        (btn) => btn.getAttribute('aria-controls') === normalizedTarget || normalizeTarget(btn.getAttribute('data-bs-target')) === normalizedTarget
      );

      if (desktopButton) {
        desktopButton.classList.add('active');
        desktopButton.setAttribute('aria-selected', 'true');
      }

      // Activate matching mobile option
      const dropdownOption = dropdownOptions.find((option) => normalizeTarget(option.getAttribute('data-bs-target')) === normalizedTarget);

      if (dropdownOption) {
        // dropdownOption.classList.add('active');
        dropdownOption.setAttribute('aria-current', 'true');
        if (buttonDropdown) {
          buttonDropdown.textContent = dropdownOption.textContent;
        }
      } else if (desktopButton && buttonDropdown) {
        buttonDropdown.textContent = desktopButton.textContent;
      }

      // Activate content pane
      const targetContent = tabElement.querySelector<HTMLElement>(withHashTarget);

      if (targetContent) {
        targetContent.classList.add('show', 'active');
        targetContent.setAttribute('aria-hidden', 'false');
      }
    };

    tabButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        activateTab(button.getAttribute('aria-controls'));
        closeDropdown();
      });
    });

    if (buttonDropdown && dropdownMenu && idDropdown) {
      buttonDropdown.setAttribute('aria-controls', `${idDropdown}-menu`);
      dropdownMenu.setAttribute('aria-labelledby', idDropdown);
      buttonDropdown.addEventListener('click', () => {
        const isExpanded = buttonDropdown.getAttribute('aria-expanded') === 'true';

        buttonDropdown.setAttribute('aria-expanded', String(!isExpanded));
        buttonDropdown.classList.toggle('show', !isExpanded);
        dropdownMenu.classList.toggle('show', !isExpanded);
      });

      document.addEventListener('click', handleOutsideClick);
    }

    dropdownOptions.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        activateTab(option.getAttribute('data-bs-target'));
        closeDropdown();
      });
    });

    const existingActiveTab =
      tabButtons.find((button) => button.classList.contains('active')) ??
      dropdownOptions.find((option) => option.getAttribute('aria-current') === 'true');

    if (existingActiveTab) {
      activateTab(existingActiveTab.getAttribute('aria-controls') ?? existingActiveTab.getAttribute('data-bs-target'));
    } else if (tabButtons[0]) {
      activateTab(tabButtons[0].getAttribute('aria-controls'));
    }
  });
};

document.addEventListener('DOMContentLoaded', setupTabs);
